import { MetabotUiControls } from "metabase-types/store";

export const DEFAULT_UI_CONTROLS: MetabotUiControls = {
  isShowingRawTable: false,
};

export const DEFAULT_TABLE_SETTINGS = {
  "table.pivot": false,
};
